var loc;

Drupal.behaviors.sw_click_dimensions = {
  attach: function( context, settings ) {
    $('.js-clickdimensions-pop').once('sw-click-dimensions-pop').each(function() {
      var cdp = new ClickDimensionsPop($(this));
    });
  }
};

var ClickDimensionsPop = function( $wrap ) {
  var _this = this;

  this.$wrap = $wrap;
  this.href = this.$wrap.attr('href');
  this.loc = null;
  this.page_id = null;
  this.is_iframe = this.$wrap.hasClass('js-clickdimensions-pop--iframe');
  var m = /^(https?:\/\/analytics\.clickdimensions\.com\/.*\/)([a-z0-9]+)\.html$/gi.exec(this.href);
  if ( m ) {
    this.loc = m[1];
    this.page_id = m[2];
  } else {
    console.error('Unable to parse ClickDimensions URL: '+this.href);
    return;
  }

  this.$wrap.on('click', function( e ) {
    e.preventDefault();
    if ( _this.is_iframe ) {
      _this.open_iframe();
    } else {
      _this.open();
    }
  });

  this.$wrap.data('sw-click-dimensions-pop', this);
}

ClickDimensionsPop.prototype.open = function() {
  loc = this.loc;
  let title = this.$wrap.html();
  if ( this.$wrap.data('title')) {
    title = this.$wrap.data('title');
  }
  var content = '<h3>'+title+'</h3>';
  content += '<div pageID="'+this.page_id+'"></div>';
  pu.open(content);
  setTimeout(function() {
    CDWidget.loadWidget();
  }, 200);
};

ClickDimensionsPop.prototype.open_iframe = function() {
  loc = this.loc;
  let title = this.$wrap.html();
  if ( this.$wrap.data('title')) {
    title = this.$wrap.data('title');
  }
  var content = '<h3>'+title+'</h3>';
  content += '<div class="clickdimensions-iframe-wrap"><iframe src="'+this.href+'" allowtransparency="true" width="100%" height="300px" type="text/html" frameborder="0" style="border:0"></iframe></div>';
  pu.open(content);
};
